import React, { useMemo } from 'react';
import { CatSprite, CatSpriteType } from './CatSprite';
import { Spinner } from '@scale/scaleui-radix';

const FunSkeleton: React.FC = () => {
  const randomSprites = useMemo(() => {
    const allSprites = Object.values(CatSpriteType);
    const shuffled = [...allSprites].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 5);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-4 bg-gradient-to-br from-blue-50 to-purple-50 p-4">
      <div className="flex gap-4">
        {randomSprites.map((spriteType, _) => (
          <CatSprite key={`${spriteType}`} imageType={spriteType} />
        ))}
      </div>

      <div className="flex flex-row items-center justify-center gap-2">
        <Spinner />
        <div className="text-lg font-bold">Loading your data...</div>
      </div>

      <div className="text-sm font-medium italic">This message is approved by mz.</div>
    </div>
  );
};

export default FunSkeleton;
